import Service from "../../../Services/index";

const Customer = {
    namespaced: true,
    state: {
        data: [],
        provinces_tax: [],
        districts_tax: [],
        sub_districts_tax: [],
        customerOther: [],
        validate_phone: "",
        remove_customer_other: [],
        //fix
        setting: {
            id: "",
            fix: ""
        },
        km: '',
        km_other: '',
        CustomerForm: {
            id: "",
            customer_id: "",
            first_name: "",
            last_name: "",
            address: "",
            store_name: "",
            phone: "",
            phone2: "",
            phone3: "",
            email: "",
            sale: "",
            province: null,
            district: null,
            sub_district: null,
            post_code: "",
            transport_customer: [],
            distance: "",
            credit_limit: 0,
            tax_number: "",
            have_new_address: "",
            display_address_tax: '',
            file: "",
            ban_promotion: "",
            address_tax: {
                tax_number: '',
                tax_name: '',
                province: null,
                district: null,
                sub_district: null,
                address: null,
                post_code: "",
                provinces_id: null,
                districts_id: null,
                sub_districts_id: null,
            },
            address_tax_1: {
                tax_number: '',
                tax_name: '',
                province: null,
                district: null,
                sub_district: null,
                address: null,
                post_code: "",
                provinces_id: null,
                districts_id: null,
                sub_districts_id: null,
            },
            address_tax_2: {
                tax_number: '',
                tax_name: '',
                province: null,
                district: null,
                sub_district: null,
                address: null,
                post_code: "",
                provinces_id: null,
                districts_id: null,
                sub_districts_id: null,
            },
            address_tax_3: {
                tax_number: '',
                tax_name: '',
                province: null,
                district: null,
                sub_district: null,
                address: null,
                post_code: "",
                provinces_id: null,
                districts_id: null,
                sub_districts_id: null,
            },
            transport_form: [],
            fixed_rate_status: "",
            special_customer: "",
        },
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
        search: {
            customer: "",
            seller: "",
            credit: '',
        },
        customer_other: [{ //เก็บแยก ไม่เก็บในฟอร์ม
            id: "",
            store_name: "",
            address: "",
            phone: "",
            status_transport_driver: "",
            status_transport_form: "",
            fixed_rate_status: "",
            distance: "",
            transport_price: [],
            transport_form: []
        }],
        transport_form: [], //เก็บแยก ไม่เก็บในฟอร์ม
        transport_form1: [], //เก็บแยก ไม่เก็บในฟอร์ม
        transport_price: [],
        transport_type_wrap: [],
    },
    mutations: {
        GET_CUSTOMER: (state, res) => {
            state.data = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.form,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            };
        },
        GET_CUSTOMER_TRANSPORT_FORM: (state, res) => {
            state.transport_form = res;
        },
        GET_CUSTOMER_TRANSPORT_PRICE: (state, res) => {
            state.transport_price = res;
        },
        GET_PROVINCE_TAX: (state, data) => {
            state.provinces_tax = data
        },
        GET_DISTRICTS_TAX: (state, data) => {
            state.districts_tax = data
        },
        GET_SUB_DISTRICTS_TAX: (state, data) => {
            state.sub_districts_tax = data
        },
        SET_SUB_CUSTOMER_FORM: (state, res) => {
            state.customer_other = res;
            state.km_other = res[0].distance;
            state.customer_other.transport_price = [{
                transport_price: [
                    ...state.transport_price
                ]
            }];
            state.customer_other.transport_form = [{
                transport_form: [
                    ...state.transport_form
                ]
            }];
        },
        SET_CUSTOMER_FORM: (state, res) => {
            //address_tax
            state.CustomerForm = res;
            state.km = res.distance;
            if (!state.CustomerForm.address_tax) {
                state.CustomerForm.address_tax = {
                    tax_number: '',
                    provinces_id: null,
                    districts_id: null,
                    sub_districts_id: null,
                    province: null,
                    district: null,
                    sub_district: null,
                    address: null,
                    post_code: "",
                }
            }
            if (!state.CustomerForm.address_tax_1) {
                state.CustomerForm.address_tax_1 = {
                    tax_number: '',
                    tax_name: '',
                    provinces_id: null,
                    districts_id: null,
                    sub_districts_id: null,
                    province: null,
                    district: null,
                    sub_district: null,
                    address: null,
                    post_code: "",
                }
            }
            if (!state.CustomerForm.address_tax_2) {
                state.CustomerForm.address_tax_2 = {
                    tax_number: '',
                    tax_name: '',
                    provinces_id: null,
                    districts_id: null,
                    sub_districts_id: null,
                    province: null,
                    district: null,
                    sub_district: null,
                    address: null,
                    post_code: "",
                }
            }
            if (!state.CustomerForm.address_tax_3) {
                state.CustomerForm.address_tax_3 = {
                    tax_number: '',
                    tax_name: '',
                    provinces_id: null,
                    districts_id: null,
                    sub_districts_id: null,
                    province: null,
                    district: null,
                    sub_district: null,
                    address: null,
                    post_code: "",
                }
            }
            //customer_other
            else {
                state.customer_other = [{
                    id: "",
                    store_name: "",
                    address: "",
                    phone: "",
                    status_price_transport: "",
                    status_transport_form: "",
                    distance: "",
                    transport_price: [
                        ...state.transport_price
                    ],
                    transport_form: [
                        ...state.transport_form
                    ]
                }]
            }
        },
        CLEAR_FORM_DATA: (state) => {
            state.provinces_tax = [];
            state.districts_tax = [];
            state.sub_districts_tax = [];
            state.remove_customer_other = [];
            state.CustomerForm = {
                id: "",
                customer_id: "",
                first_name: "",
                last_name: "",
                address: "",
                store_name: "",
                phone: "",
                phone2: "",
                phone3: "",
                email: "",
                sale: "",
                province: null,
                district: null,
                sub_district: null,
                post_code: "",
                transport_customer: [],
                distance: "",
                credit_limit: 0,
                tax_number: "",
                have_new_address: "",
                display_address_tax: '',
                file: "",
                ban_promotion: "",
                address_tax: {
                    tax_number: '',
                    tax_name: '',
                    province: null,
                    district: null,
                    sub_district: null,
                    address: null,
                    post_code: "",
                    provinces_id: null,
                    districts_id: null,
                    sub_districts_id: null,
                },
                address_tax_1: {
                    tax_number: '',
                    tax_name: '',
                    province: null,
                    district: null,
                    sub_district: null,
                    address: null,
                    post_code: "",
                    provinces_id: null,
                    districts_id: null,
                    sub_districts_id: null,
                },
                address_tax_2: {
                    tax_number: '',
                    tax_name: '',
                    province: null,
                    district: null,
                    sub_district: null,
                    address: null,
                    post_code: "",
                    provinces_id: null,
                    districts_id: null,
                    sub_districts_id: null,
                },
                address_tax_3: {
                    tax_number: '',
                    tax_name: '',
                    province: null,
                    district: null,
                    sub_district: null,
                    address: null,
                    post_code: "",
                    provinces_id: null,
                    districts_id: null,
                    sub_districts_id: null,
                },
                transport_form: [],
                fixed_rate_status: "",
                special_customer: "",
            };

            state.customer_other = [{
                id: "",
                store_name: "",
                address: "",
                phone: "",
                status_price_transport: "",
                status_transport_form: "",
                transport_price: [
                    ...state.transport_price
                ],
                transport_form: [
                    ...state.transport_form
                ]
            }];
        },
        SET_SHIPPING_TRANSPORT: (state, data) => {
            state.CustomerForm.transport_customer = data;
        },
        SET_SHIPPING_SUB_TRANSPORT: (state, data) => {
            state.customer_other.transport_price = data;
        },
        SET_TRANSPORT_TYPE_WRAP: (state, res) => {
            state.transport_type_wrap = res;
        },

        //customer other
        ADD_CUSTOMER_OTHER: (state) => {
            state.customer_other = [
                ...state.customer_other,
                {
                    id: "",
                    store_name: "",
                    address: "",
                    phone: "",
                    status_price_transport: "",
                    status_transport_form: "",
                    transport_price: [
                        ...state.transport_price
                    ],
                    transport_form: [
                        ...state.transport_form
                    ]
                }
            ]
        },
        GET_CUSTOMER_OTHER_BY_ID: (state, res) => {
            if (res.length > 0) {
                state.customer_other = res;
            } else {
                state.customer_other = [{
                    id: "",
                    store_name: "",
                    address: "",
                    phone: "",
                    status_price_transport: "",
                    status_transport_form: "",
                    transport_price: [
                        ...state.transport_price
                    ],
                    transport_form: [
                        ...state.transport_form
                    ]
                }]
            }
        },
        REMOVE_CUSTOMER_OTHER: (state, index) => {
            state.remove_customer_other = [
                ...state.remove_customer_other,
                state.customer_other[index] ? state.customer_other[index].id : null
            ];
            state.customer_other = state.customer_other.filter(
                (detail, itemIndex) => index !== itemIndex
            );
        },
        CLEAR_SEARCH: (state) => {
            state.search = {
                customer: "",
                seller: ""
            }
        },

        //fix
        SETTING_FIX: (state, res) => {
            if (res) {
                state.setting = {
                    id: res.id,
                    fix: res.fix
                };
            } else {
                state.setting = {
                    id: "",
                    fix: ""
                }
            }
        }
    },
    actions: {
        updateCustomerTransportPrice({commit}, list) {
            return Service.customer.updateCustomerTransportPrice(list)
        },
        updateCustomerOtherTransportPrice({commit}, list) {
            return Service.customer.updateCustomerOtherTransportPrice(list)
        },
        setCustomer({commit}, page = 1) {
            return Service.customer.getCustomer(page).then(response => {
                commit("GET_CUSTOMER", response);
            });
        },
        setAllCustomer({commit}) {
            return Service.customer.getAllCustomer();
        },
        setAllCustomerDropdown({commit}) {
            return Service.customer.setAllCustomerDropdown();
        },
        show({commit}, id) {
            return Service.customer.showCustomer(id).then(response => {
                commit("SET_CUSTOMER_FORM", response);
            });
        },
        showSub({commit}, id) {
            return Service.customer.showSubCustomer(id).then(response => {
                commit("SET_SUB_CUSTOMER_FORM", response);
            });
        },
        save({commit, state}, {id, data}) {
            //formData send file
            if (!id) {//create
                return Service.customer.createCustomer(data);
            } else {//update
                return Service.customer.updateCustomer(id, data);
            }
        },
        uploadFileCustomer({commit}, data) {
            return Service.customer.uploadFileCustomer(data);
        },
        delete({commit}, id) {
            return Service.customer.deleteCustomer(id);
        },
        search({commit}, {page = 1, customer, sale}) {
            return Service.customer.searchCustomer(page, customer, sale)
                .then(response => {
                    commit("GET_CUSTOMER", response);
                });
        },
        clearFormData({commit}) {
            commit("CLEAR_FORM_DATA");
        },

        //shipping
        addShippingTransport({commit}, data) {
            commit("SET_SHIPPING_TRANSPORT", data)
        },
        addShippingSubTransport({commit}, data) {
            commit("SET_SHIPPING_SUB_TRANSPORT", data)
        },
        searchByShipping({commit}, {page = 1, search}) {
            let data = {
                name: search.name,
                area_id: "",
                province_id: "",
                districts_id: "",
            };
            if (search.area) {
                data.area_id = search.area.id
            }
            if (search.province) {
                data.province_id = search.province.id
            }
            if (search.district) {
                data.districts_id = search.district.id
            }
            return Service.Shipping.searchSeller(page, data)
                .then(res => {
                    commit("GET_CUSTOMER", res);
                })
        },

        generateCustomerID({commit}, data) {
            return Service.customer.generateCustomerID(data);
        },
        clearSearch({commit}) {
            commit("CLEAR_SEARCH");
        },
        setProvince({commit}) {
            return Service.Common.getProvince().then(data => {
                commit("GET_PROVINCE_TAX", data);
            });
        },
        setDistrict({commit}, province_code) {
            return Service.Common.searchDistricts(province_code).then(data => {
                //console.log(data);
                commit("GET_DISTRICTS_TAX", data);
            })
        },
        setSubDistrict({commit}, district_code) {
            return Service.Common.searchSubDistricts(district_code).then(data => {
                //console.log(data);
                commit("GET_SUB_DISTRICTS_TAX", data);
            })
        },
        getCustomerOtherById({commit}, customer_id) {
            return Service.customer.getCustomerOtherById(customer_id);
        },
        setFixedRate({commit}, data) {
            return Service.customer.setFixedRate(data);
        },
        getCustomerTransportForm({commit}) {
            return Service.customer.getCustomerTransportForm().then(data => {
                commit("GET_CUSTOMER_TRANSPORT_FORM", data);
            });
        },
        getCustomerTransportPrice({commit}) {
            return Service.transportType.getTransportType().then(res => {
                commit("GET_CUSTOMER_TRANSPORT_PRICE", res.filter(data => data.id != 4));
            })
        },
        getTransportTypeWrap({commit}) {
            return Service.customer.getTransportTypeWrap().then(data => {
                commit("SET_TRANSPORT_TYPE_WRAP", data);
            })
        },
        updateCustomerTransport({commit}, data) {
            return Service.customer.uploadTransportCustomer(data);
        },
        uploadTransportOtherCustomer({commit}, data) {
            return Service.customer.uploadTransportOtherCustomer(data);
        },
        saveTransportFeeCustomer({commit}, data) {
            return Service.customer.saveTransportFeeCustomer(data);
        },
        saveTransportFeeCustomerOther({commit}, data) {
            return Service.customer.saveTransportFeeCustomerOther(data);
        },

        //customer other
        addCustomerOther({commit}) {
            commit("ADD_CUSTOMER_OTHER");
        },
        removeCustomerOther({commit}, index) {
            commit("REMOVE_CUSTOMER_OTHER", index);
        },
        saveCustomerOther({commit}, data) {
            return Service.customer.createCustomerOther(data)
        },
        getCustomerOtherList({commit}, page = 1) {
            return Service.customer.getCustomerOtherList(page);
        },
        getCustomerOtherByCustomerId({commit}, customer_id) {
            return Service.customer.getCustomerOtherById(customer_id).then(res => {
                commit("GET_CUSTOMER_OTHER_BY_ID", res)
            })
        },
        //setting fix for customer other
        getSettingFix({commit}) {
            return Service.customer.getSettingFix().then(res => {
                commit("SETTING_FIX", res)
            });
        },
        saveSettingFix({commit}, {id, data}) {
            //console.log(data);
            if (!id) {
                return Service.customer.createSettingFix(data);
            } else {
                return Service.customer.updateSettingFix(id, data);
            }
        },
        getCustomerTransportEdit({commit}, {page = 1, data}) {
            //console.log(data)
            return Service.customer.getCustomerTransportEdit(page, data);
        },
        getCustomerSubTransportEdit({commit}, {page = 1, data}) {
            //console.log(data)
            return Service.customer.getCustomeSubrTransportEdit(page, data);
        },
        exportTran({commit}, data) {
            return Service.customer.exportTran(data);
        },
        exportTrip({commit}, data) {
            return Service.customer.exportTrip(data);
        }
    }
};

export default Customer;
